import type { Session } from '@product-portal/shared';
import { KpiCard, KpiGrid } from '@/components/portal/kpi-card';
import { RequestListCard } from '@/features/requests/request-list-card';
import { useRequestSummary } from '@/hooks/use-requests';
import { currentMonthName } from '@/lib/format';

/**
 * 01 · Accueil.
 * Not reproduced from the mock-up, for lack of a source (see CLAUDE.md, « Écarts lot 2 »):
 * the job title under the greeting (no column) and « Données synchronisées avec Jira » (Jira is lot 3).
 */
export function HomePage({ session }: { session: Session }) {
  const summary = useRequestSummary();
  const s = summary.data;
  const dash = '—';
  return (
    <>
      <div className="flex flex-col gap-1">
        <h1 className="m-0 text-[26px] font-black tracking-[-0.01em]">Bonjour {session.user.firstName}</h1>
        <p className="m-0 text-sm text-muted-foreground">{session.teams.map((t) => t.name).join(' · ')}</p>
      </div>

      <KpiGrid>
        <KpiCard
          label="Mes demandes ouvertes"
          value={s?.openCount ?? dash}
          hint={s ? `${s.inProgressCount} en cours de réalisation` : undefined}
        />
        <KpiCard
          label="En attente de ma réponse"
          value={s?.awaitingMyReplyCount ?? dash}
          tone={s && s.awaitingMyReplyCount > 0 ? 'warning' : 'default'}
          hint={s ? (s.awaitingMyReplyCount > 0 ? "L'équipe produit a posé une question" : 'Aucune question en attente') : undefined}
        />
        <KpiCard
          label="Livrées ce mois"
          value={s?.deliveredThisMonthCount ?? dash}
          tone="success"
          hint={`Depuis le 1er ${currentMonthName()}`}
        />
        {/* Shown only when the user may see its team's requests (team option, Référent, PO). */}
        {s?.team && <KpiCard label="Demandes de mon équipe" value={s.team.count} hint={s.team.teamNames.join(' · ')} />}
      </KpiGrid>

      <RequestListCard title="Mes demandes" scope="mine" />
    </>
  );
}
